import script from "./FixedBackHome.vue?vue&type=script&lang=ts&setup=true"
export * from "./FixedBackHome.vue?vue&type=script&lang=ts&setup=true"

import "./FixedBackHome.vue?vue&type=style&index=0&id=beb92e5e&lang=less"

const __exports__ = script;

export default __exports__